import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=078d347c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=078d347c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d347c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078d347c')) {
      api.createRecord('078d347c', component.options)
    } else {
      api.reload('078d347c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=078d347c&scoped=true&", function () {
      api.rerender('078d347c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CdtCGAoy68A6/JS/comp/SearchFilterTokens.vue"
export default component.exports